/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandAlpineJs = createReactComponent("brand-alpine-js", "IconBrandAlpineJs", [
  ["path", { d: "M3 11.5l4.5 4.5h9l-9 -9z", key: "svg-0" }],
  ["path", { d: "M16.5 16l4.5 -4.5l-4.5 -4.5l-4.5 4.5", key: "svg-1" }]
]);

export { IconBrandAlpineJs as default };
//# sourceMappingURL=IconBrandAlpineJs.js.map
